var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMortgages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 24L10 20M10 20L24 6L38 20M10 20V40C10 41.1046 10.8954 42 12 42H18M38 20L42 24M38 20V40C38 41.1046 37.1046 42 36 42H30M18 42C19.1046 42 20 41.1046 20 40V32C20 30.8954 20.8954 30 22 30H26C27.1046 30 28 30.8954 28 32V40C28 41.1046 28.8954 42 30 42M18 42H30",
    fill: "none",
    stroke: "current",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMortgages);
export default __webpack_public_path__ + "static/media/mortgages.0e7e84fa9c55f10ce7182c7fd0c7a523.svg";
export { ForwardRef as ReactComponent };